export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/dashboard/home/Home.vue'),
  },
  {
    path: '/stat',
    name: 'stat',
    component: () => import('@/views/dashboard/stat/Stat.vue'),
  },
  {
    path: '/stat-clients',
    name: 'stat-clients',
    component: () => import('@/views/dashboard/stat-clients/StatClients.vue'),
  },
  {
    path: '/fichiers-azure',
    name: 'fichiers-azure',
    component: () => import('@/views/dashboard/fichiers-azure/FichiersAzure.vue'),
  },
  {
    path: '/signatures-hf',
    name: 'signatures-hf',
    component: () => import('@/views/dashboard/signatures-hf/SignaturesHf.vue'),
  },
  {
    path: '/docs',
    name: 'docs',
    component: () => import('@/views/dashboard/docs/DocsList.vue'),
    meta: {
      pageTitle: 'Documentation BUXIDA',
      breadcrumb: [
        { text: 'Documentation', active: true },
      ],
    },
  },
  {
    path: '/docs/:slug',
    name: 'docs-detail',
    component: () => import('@/views/dashboard/docs/DocsDetail.vue'),
    meta: {
      pageTitle: 'Documentation BUXIDA',
      breadcrumb: [
        { text: 'Documentation', to: { name: 'docs' } },
        { text: 'Détail', active: true },
      ],
    },
  },
]
